import React, { useEffect, useState } from "react";
import { collection, deleteDoc, doc, getDocs, query, where, Timestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { useAuth } from "../../AuthContext";

// Admin: every photo post that's live right now (food specials and pull-tab
// updates), with a Remove button for anything that shouldn't be up.

function ymd(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function when(ts) {
  const d = ts && typeof ts.toDate === "function" ? ts.toDate() : null;
  return d ? d.toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";
}

export default function AdminPosts() {
  const { role } = useAuth();
  const [posts, setPosts] = useState(null);
  const [error, setError] = useState("");

  const load = async () => {
    setError("");
    try {
      const [food, tabs] = await Promise.all([
        getDocs(query(collection(db, "todaysSpecials"), where("date", "==", ymd(new Date())))),
        getDocs(query(collection(db, "pulltabPosts"), where("expiresAt", ">", Timestamp.now()))),
      ]);
      setPosts([
        ...tabs.docs.map((d) => ({ id: d.id, col: "pulltabPosts", kind: "Pull-tab update", ...d.data() })),
        ...food.docs.map((d) => ({ id: d.id, col: "todaysSpecials", kind: "Food special", ...d.data() })),
      ]);
    } catch (e) {
      setError(e.message);
      setPosts([]);
    }
  };

  useEffect(() => {
    if (role === "admin") load();
  }, [role]);

  if (role !== "admin") return <p style={{ color: "#fff" }}>Admins only.</p>;

  const remove = async (p) => {
    if (!window.confirm(`Remove this ${p.kind.toLowerCase()} from ${p.barName || "this bar"}? It disappears from the app right away.`)) return;
    try {
      await deleteDoc(doc(db, p.col, p.id));
      setPosts((prev) => prev.filter((x) => !(x.col === p.col && x.id === p.id)));
    } catch (e) {
      setError(`Couldn't remove it: ${e.message}`);
    }
  };

  return (
    <div style={{ color: "#fff", maxWidth: "900px" }}>
      <h2 style={{ margin: "0 0 6px" }}>Live posts</h2>
      <p style={{ margin: "0 0 18px", color: "#B8B0C8" }}>
        Photos bars and their staff have posted that customers can see right now. Remove anything that shouldn't be up.
      </p>
      {error && <p style={{ color: "#FF6B8A" }}>{error}</p>}
      {posts === null && <p style={{ color: "#B8B0C8" }}>Loading…</p>}
      {posts && posts.length === 0 && <p style={{ color: "#B8B0C8" }}>No live posts right now.</p>}
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {(posts || []).map((p) => (
          <div key={`${p.col}-${p.id}`} style={{ background: "#0D0B1A", borderRadius: "12px", padding: "14px", display: "flex", gap: "14px", alignItems: "center", flexWrap: "wrap" }}>
            {p.photoUrl && <img src={p.photoUrl} alt="" style={{ width: "96px", height: "96px", objectFit: "cover", borderRadius: "10px" }} />}
            <div style={{ flex: "1 1 260px", minWidth: 0 }}>
              <div style={{ fontSize: "13px", color: "#FF6FA3", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em" }}>{p.kind}</div>
              <div style={{ fontSize: "17px", fontWeight: 700 }}>{p.barName || p.barId}</div>
              <div style={{ color: "#D6D2E4" }}>{p.caption}</div>
              <div style={{ color: "#8A84A0", fontSize: "14px" }}>
                Posted by {p.postedBy || "?"} · {when(p.createdAt)}
              </div>
            </div>
            <button
              type="button"
              onClick={() => remove(p)}
              style={{ minHeight: "44px", padding: "0 16px", borderRadius: "10px", border: "1px solid #F472B6", background: "transparent", color: "#F472B6", fontWeight: 700, cursor: "pointer" }}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
